import { formatCurrency } from "@utils/currency";
import React from "react";

interface DateRange {
  start: Date;
  end: Date;
}

interface PeakPeriodProps {
  normalDays: number;
  normalDateRanges: DateRange[];
  cautionFee?: string | number;
  partyCautionFee?: string | number;
  currency: string;
  surgeDays?: { date: string; price: number }[];
  surgeDateRanges?: DateRange[];
  surgePrice?: number;
  mainNormalPrice?: number;
  normalPrice?: number;
  partyPrice?: number | string;
  isPartyPrice?: boolean;
  serviceFee?: number;
}

const PeakPeriod: React.FC<PeakPeriodProps> = ({
  normalDays,
  // normalDateRanges,
  cautionFee,
  partyCautionFee,
  currency,
  mainNormalPrice,
  partyPrice,
  isPartyPrice,
  serviceFee = 0,
}) => {
  const totalDays = normalDays;

  const dailyPrice = isPartyPrice
    ? Number(partyPrice) || 0
    : mainNormalPrice || 0;

  const activeCautionFee =
    Number(isPartyPrice ? partyCautionFee : cautionFee) || 0;

  const totalPrice = dailyPrice * totalDays + activeCautionFee + serviceFee;

  const lineItemLabelStyle: React.CSSProperties = {
    textDecoration: "underline",
    color: "#333",
    fontWeight: 400,
  };

  return (
    <div className="px-3 py-2">
      {/* Rental price line */}
      <div className="d-flex justify-content-between align-items-center mb-3 font-onest">
        <span style={lineItemLabelStyle} className="fs-6 font-onest">
          {currency}
          {formatCurrency(dailyPrice)} x {totalDays}{" "}
          {totalDays > 1 ? "days" : "day"}
        </span>
        <span className="fs-6 text-dark font-onest">
          {currency}
          {formatCurrency(dailyPrice * totalDays)}
        </span>
      </div>

      {/* Caution fee line */}
      {activeCautionFee > 0 && (
        <div className="d-flex justify-content-between align-items-center mb-3 font-onest">
          <span style={lineItemLabelStyle} className="fs-6 font-onest">
            {isPartyPrice ? "Party caution fee" : "Caution fee"}
          </span>
          <span className="fs-6 text-dark font-onest">
            {currency}
            {formatCurrency(activeCautionFee)}
          </span>
        </div>
      )}

      {/* Service fee line */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span style={lineItemLabelStyle} className="fs-6 font-onest">
          Service fee
        </span>
        <span className="fs-6 text-dark font-onest">
          {currency}
          {formatCurrency(serviceFee)}
        </span>
      </div>

      <hr className="my-3" style={{ borderColor: " #575656" }} />

      <div className="d-flex justify-content-between align-items-center">
        <span className="fs-6 fw-bold text-dark font-onest">Total</span>
        <span className="fs-6 fw-bold text-dark font-onest">
          {currency}
          {formatCurrency(totalPrice)}
        </span>
      </div>
    </div>
  );
};

export default PeakPeriod;
